import React from 'react';

const styles = {
    logo: {
        width: 240,
        height: 125,
        margin: '1em auto'
    },
    logoImage: {width: '100%', height: 'auto'}
};

const LoginLogo = () => {
    return (
        <div style={styles.logo}>
            <img src="CloudSent-POS-logo-admin.png" style={styles.logoImage} alt="CloudSent POS"/>
        </div>
    )
};

export default LoginLogo;



// WEBPACK FOOTER //
// ./src/Fuse/components/LoginLogo.js